import {
  take,
  put,
  fork,
  cancel,
  select,
  cancelled,
  actionChannel,
  call,
} from "redux-saga/effects"

import { selectEvent } from "src/engine/modules/calendar"
import devlog from "src/helpers/devlog"
import { request } from "src/engine/modules/session/effects"
import { normalize as normalizeModel } from "src/engine/modules/model/helpers"
import { showToast } from "@infotech/uikit-toasts"
import getWordByModelName from "src/helpers/text/getWordByModelName"
import getWordEnding from "../helpers/getWordEnding"
import { process as selectProcess, entityItem } from "../selectors"
import { types, creators } from "../actions"

function* remove(action, name) {
  const { id, model } = action

  try {
    const { getUrl, getRestUrn } = normalizeModel(model)

    const requestURL = getRestUrn ? getRestUrn(`delete`, id) : getUrl(id) // TODO: remove getUrl support

    yield request(
      requestURL,
      {},
      {
        method: `DELETE`,
      },
    )
    yield put(creators.remove.success(model, id, true))
    showToast({
      type: `success`,
      message: `${getWordByModelName(model.name, false, true)} ${
        name ? `"${name}" ` : ``
      }успешно удален${getWordEnding(model.name)}.`,
      hideIn: 5,
    })
  } catch (error) {
    devlog(error)
    yield put(creators.remove.error(model, id, error))
  } finally {
    if (yield cancelled()) {
      yield put(creators.remove.cancel(model, id))
    }
  }
}

export default function* removeSaga() {
  const removeRequest = yield actionChannel([types.remove, types.removeCancel])
  while (true) {
    const action = yield take(removeRequest)

    const { id, model, callback } = action

    const process = yield select(selectProcess, model, id)

    if (action.type === types.remove) {
      // Detect current action is works
      if (process) {
        switch (process.type) {
          // Ignore if already removing
          case types.remove:
            return
          // Cancel all I/O
          case types.read:
          case types.update:
            yield cancel(process.task)
            break
          case types.create:
            throw new Error(`Illegal action type of current process`)
          default:
            throw new Error(`Unknown entity action type founded`)
        }
      }
      let { data } = yield select(entityItem, model, id)

      // when entity remove being dispatched reducer creates entity
      // in store with data null, so we need to look in different place
      if (data === null && model.name === `events`) {
        data = yield select(selectEvent, id)
      }
      const { name } = data
      const task = yield fork(remove, action, name)
      yield put(creators.processing.start(types.remove, task, model, id))
      yield fork(function* watchFork() {
        yield task.toPromise().then(() => {})
        yield put(creators.processing.complete(types.remove, task, model, id))
        if (callback && typeof callback === `function`) {
          yield call(callback, id)
        }
      })
      // If fetch completed, we should erase existen progress
    } else if (action.type === types.removeCancel) {
      if (process) {
        const { task } = process
        if (process.type === types.remove) {
          yield cancel(task)
        } else {
          throw new Error(
            `Unexpected cancellation of process with another task`,
          )
        }
      }
    }
  }
}
